<template>
    <div id="resourceContainer" class="show" v-if="isPortrait">
        <div class="title">
            <span class="typography--s4 text-uppercase text-center">
                {{$t('1081')}}
                <!-- Resources -->
            </span>
            <button @click="closeResource()" id="btnResourceToggle"></button>
            <div class="clearfix"></div>
        </div>
        <div class="container">
            <div class="typography--s4 text-center"  v-html="currentTimelineContents.text">
                <!-- {{currentTimelineContents.text}} -->
            </div>
        </div>
    </div>
    <div id="quizDetailContainer" v-else>
        <div>
            <header class="mdc-top-app-bar position-init">
                <div class="mdc-top-app-bar__row">
                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                        <a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeResource()">close</a>
                    </section>
                    
                    <section class="mdc-top-app-bar__section title">
                        <div class="mdc-top-app-bar__title">
                            {{$t('1081')}}
                            <!-- Resources -->
                        </div>                
                    </section>

                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                        <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                    </section>
                </div>
            </header>
            <section id="quizDetailContents" v-html="currentTimelineContents.text"></section>
        </div>
    </div>
   
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 리소스 컨텐츠 컴포넌트(my learning lesson study - timeline resource contents component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
function isPortrait() {
    if (screen.orientation === undefined) {
        return window.orientation === 0 || window.orientation === 180;
    } else {
        return screen.orientation.angle === 0;
    }
}
    
export default {
    props: ['currentTimelineContents'],
    data() {
        return {
            isPortrait: isPortrait()
        }
    },
    mounted() {
        // 화면 회전 이벤트가 발생했을 경우(When a screen rotation event)
        window.addEventListener('orientationchange', (aaa) => {
            this.isPortrait = isPortrait()
            if (!this.isPortrait) {
                this.openResource()
            }
        })

        // 처음 실행될 경우 가로 세로 모드 체크(When running for the first time, check the portrait mode)
        if (!this.isPortrait) {
            this.openResource()
        }
    },
    
    methods: {
        // 닫기(close)
        closeResource() {
            this.$emit('closeResource')
        },

        // 열기(open)
        openResource() {
            this.$emit('openResource')
        },
    }
}
</script>